/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Err_Existing_TitleInputs */

const es_ab_err_existing_title = /** @type {(inputs: Ab_Err_Existing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta existente`)
};

const gl_ab_err_existing_title = /** @type {(inputs: Ab_Err_Existing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta existente`)
};

const en_ab_err_existing_title = /** @type {(inputs: Ab_Err_Existing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account exists`)
};

/**
* | output |
* | --- |
* | "Account exists" |
*
* @param {Ab_Err_Existing_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_err_existing_title = /** @type {((inputs?: Ab_Err_Existing_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Err_Existing_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_err_existing_title(inputs)
	if (locale === "en") return en_ab_err_existing_title(inputs)
	return es_ab_err_existing_title(inputs)
});